module App.Interfaces {
    export interface ICategoryDescription {
        category: string;
        description: string;
        newcategorySort: number;
    }
}